import * as PillsDAO from "@/dao/pills-dao";
import * as WorkListsDAO from "@/dao/worklists-dao";

export default {
  async getPills({ commit }, { searchQuery, listId }) {
    commit("setPills", await PillsDAO.getPills(searchQuery, listId));
  },
  increase({ commit }, { listId, pill, query }) {
    commit("increaseAmountOfCanistersByPillId", pill.id);
    return WorkListsDAO.addPillsToWorkList(listId, [pill], query);
  },
  update({ commit }, { listId, pill, query }) {
    commit("increaseAmountOfCanistersByPillId", pill.id);
    return WorkListsDAO.updatePillsOnWorkList(listId, [pill], query);
  },
  decrease({ commit }, { listId, pill }) {
    commit("decreaseAmountOfCanistersByPillId", pill.id);
    const { worklistItemId, amountOfCanisters } = pill;
    const item = { id: worklistItemId, amountOfCanisters };
    return WorkListsDAO.updatePillsOnWorkList(listId, [item]);
  },
  setAmount({ commit }, { listId, pill, value, query }) {
    commit("setAmountOfCanistersByPillId", { pillId: pill.id, value });
    const { id, worklistItemId, amountOfCanisters } = pill;
    const item = { id: worklistItemId || id, amountOfCanisters };
    return WorkListsDAO.createPillsOnWorkList(listId, [item], query);
  },
  changePillsValueByIdsList({ commit }, { listId, pillsIdsList, value, query }) {
    pillsIdsList.forEach((p) => commit("setAmountOfCanistersByPillId", { pillId: p.id, value }));
    return WorkListsDAO.updatePillsOnWorkList(listId, pillsIdsList, query);
  },
  async addPillsValueByIdsList({ commit }, { listId, pillsIdsList, value, query }) {
    pillsIdsList.forEach((p) => commit("setAmountOfCanistersByPillId", { pillId: p.id, value }));
    const response = await WorkListsDAO.addPillsToWorkList(listId, pillsIdsList, query);
    return response;
  },
  async uploadXlsPillsFile(_, { listId, file }) {
    const { requestId } = await PillsDAO.uploadXlsFile(listId, file);
    return requestId;
  },
  getUploadStatus(_, { listId, requestId }) {
    return PillsDAO.getUploadXlsFileStatus(listId, requestId);
  },
};
